var _react_refresh_temp_1;
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
const participantAdapter = createEntityAdapter({
    selectId: (participant) => participant.userId,
    sortComparer: (a, b) => a.name.localeCompare(b.name),
});
export const participantsSelector = participantAdapter.getSelectors(_react_refresh_temp_1 = (state) => state.participants);
$RefreshReg$(_react_refresh_temp_1, "participantsSelector$participantAdapter.getSelectors");
const participantsSlice = createSlice({
    name: 'participants',
    initialState: participantAdapter.getInitialState(),
    reducers: {
        addParticipant: participantAdapter.addOne,
        removeParticipant: participantAdapter.removeOne,
        updateParticipant: participantAdapter.updateOne,
    },
});
export const { addParticipant, removeParticipant, updateParticipant } = participantsSlice.actions;
export default participantsSlice.reducer;
